import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  BooleanParam,
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";

import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import { useRole } from "components/Hooks/UserHooks";
import CountUp from "react-countup";
import { getUsers, getUsersActive, getUsersManager, putUser } from "store/user/thunk";
// import { truncate } from "utils";
import UserApi from "api/userApi";
// import { Switch } from "antd";
import countryApi from "api/countryApi";
import CollapseFilter from "components/Common/CollapseFilter";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownCountries from "components/Common/DropdownCountries";
import DropdownOption from "components/Common/DropdownOption";
import DropdownPlatform from "components/Common/DropdownPlatform";
import ModalPreview from "components/Common/ModalPreview";
import {
  COLOR_STATUS_POST,
  LIST_AGENCY_OPTION,
  LIST_CAMPAIGN_OPTION,
  LIST_CHANNEL_USER_OPTION,
  LIST_OPTION_OS,
  LIST_OPTION_PLATFORM,
  LIST_OPTION_ROLE,
  STATUS_POST_OPTION,
  USER_FCM_TOKEN_OPTION,
  USER_STATUS_SIGNUP_OPTION,
  getPlatFormImage,
} from "helpers/constans";
import { formatDateStringToKorea, formatDateStringToUTC } from "helpers/format";
import { capitalizeFirstLetter, truncate } from "utils";
import avatar1 from "../../../assets/images/users/ic_defaul_avatar2.png";
import UserForm from "./UserForm";
import BarListDetail from "pages/BarList/BarListDetail";
import DropdownAsyncBars from "components/Common/DropdownAsyncBars";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import countries from "helpers/countries";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import DropdownChannelUser from "components/Common/DropdownChannelUser";
import Permission from "components/Common/Permission";
import DropdownOptionImage from "components/Common/DropdownOptionImage";
import TermCondition from "components/Common/TermCondition";
import CopyWrapper from "components/Common/CopyWrapper";
import IPHONE_MODELS from "helpers/iphone_models";
import DropdownAsyncAgency from "components/Common/DropdownAsyncAgency";
import DropdownAsyncCampaign from "components/Common/DropdownAsyncCampaign";
import CheckboxStatusUser from "components/Common/CheckboxStatusUser";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import ModalPerNotification from "../ModalPerNotification";
import GroupInfoUser from "components/Common/GroupInfoUser";

interface Option {
  label: string;
  value: string;
}

export interface Tag {
  id: string;
  text: string;
}

registerLocale("en", en);
registerLocale("ko", ko);

const UserList = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    nickname: withDefault(StringParam, ""),
    email: withDefault(StringParam, ""),
    ip: withDefault(StringParam, ""),
    phone: withDefault(StringParam, ""),
    device_id: withDefault(StringParam, ""),
    device_model: withDefault(StringParam, ""),
    udid_2: withDefault(StringParam, ""),
    platform: withDefault(StringParam, ""),
    bar_id: withDefault(StringParam, ""),
    os: withDefault(StringParam, ""),
    country: withDefault(StringParam, "KR"),
    channel: withDefault(StringParam, ""),
    agency: withDefault(StringParam, ""),
    campaign: withDefault(StringParam, ""),
    is_deleted: withDefault(NumberParam, 0),
    is_active: withDefault(StringParam, ""),
    is_token: withDefault(StringParam, ""),
    signup_status: withDefault(StringParam, ""),
    start_date: withDefault(StringParam, ""),
    end_date: withDefault(StringParam, ""),
    type: withDefault(StringParam, "3"),
  });

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);

  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [itemToBarDetail, setItemToBarDetail] = useState<any>(null);

  const STATUS_USER_OPTION_LANG =
    STATUS_POST_OPTION?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const LIST_OPTION_ROLE_LANG =
    LIST_OPTION_ROLE?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const [nickNameSearch, setNicknameSearch] = useState<string>(
    query?.nickname || ""
  );

  const [emailSearch, setEmailSearch] = useState<string>(query?.email || "");

  const [barSearch, setBarSearch] = useState<Option | null>({
    label: t("All Filter"),
    value: "",
  });

  const [platFormSearch, setPlatFormSearch] = useState<Option | null>(
    LIST_OPTION_PLATFORM?.filter(
      (item) => String(item?.value) === String(query?.platform)
    )[0]
  );

  const [oSSearch, setOSSearch] = useState<any | null>(
    LIST_OPTION_OS?.filter(
      (item) => String(item?.value) === String(query?.os)
    )[0]?.value || ""
  );

  const [ipAddressSearch, setIPAddressSearch] = useState<string>(
    query?.ip || ""
  );

  const [phoneSearch, setPhoneSearch] = useState<string>(query?.phone || "");

  const [deviceIdSearch, setDeviceIdSearch] = useState<string>(
    query?.device_id || ""
  );

  const [deviceModelSearch, setDeviceModelSearch] = useState<string>(
    query?.device_model || ""
  );

  const [uuid2Search, setUUID2Search] = useState<string>(query?.udid_2 || "");

  const [statusSearch, setStatusSearch] = useState<any>(
    STATUS_POST_OPTION?.find(
      (item) => item?.value === parseInt(query?.is_active)
    )?.value ?? ""
  );

  const [isTokenSearch, setIsTokenSearch] = useState<any>(
    USER_FCM_TOKEN_OPTION?.find(
      (item) => item?.value == (query?.is_token)
    )?.value || ''
  );

  const [signupStatusSearch, setSignupStatusSearch] = useState<any>(
    USER_STATUS_SIGNUP_OPTION?.find(
      (item) => item?.value == (query?.signup_status)
    )?.value || ''
  );

  const [channelSearch, setChannelSearch] = useState<Option | any>(
    LIST_CHANNEL_USER_OPTION?.find((item) => item?.value === query?.channel)
      ?.value || ""
  );

  const [agencySearch, setAgencySearch] = useState<Option | any>(
    LIST_AGENCY_OPTION?.find((item) => item?.value === query?.agency)
      ?.value || {
      label: t("All Filter"),
      value: "all",
    }
  );

  const [campaignSearch, setCampaignSearch] = useState<Option | any>(
    LIST_CAMPAIGN_OPTION?.find((item) => item?.value === query?.campaign)
      ?.value || {
      label: t("All Filter"),
      value: "all",
    }
  );

  const [isDeletedUserSearch, setIsDeletedUserSearch] = useState<number>(query?.is_deleted || 0);

  const [linkImage, setLinkImage] = useState<any>(null);

  const [countrySearch, setCountrySearch] = useState<any | null>(null);

  const [listCountry, setListCountry] = useState<any>([]);
  const [itemNotification, setItemNotification] = useState(null);

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.start_date
      ? moment(query?.start_date || "", "Y-MM-DD").toDate()
      : null,
    query?.end_date ? moment(query?.end_date || "", "Y-MM-DD").toDate() : null,
  ]);
  const [start_date, end_date] = dateSearch;

  const selectLayoutState = (state: any) => state.UsersManager;

  const UserProperties = createSelector(selectLayoutState, (state) => ({
    users: state.users,
    isUserLoading: state.isUserLoading,
    isUserSuccess: state.isUserSuccess,

    error: state.error,
  }));

  // Inside your component
  const { users, isUserLoading } = useSelector(UserProperties);

  function loadTableData() {
    dispatch(getUsersManager(query));
  }

  useEffect(() => {
    loadTableData();
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    setQuery({
      ...query,
      email: emailSearch.trim() || "",
      is_active: statusSearch,
      channel: channelSearch,
      country: countrySearch?.value || "",
      bar_id: barSearch?.value !== "all" ? barSearch?.value : "",
      platform: platFormSearch?.value || "",
      os: oSSearch || "",
      ip: ipAddressSearch.trim() || "",
      nickname: nickNameSearch.trim() || "",
      phone: phoneSearch.trim() || "",
      device_id: deviceIdSearch.trim() || "",
      device_model: deviceModelSearch.trim() || "",
      udid_2: uuid2Search.trim() || "",
      agency: agencySearch?.value,
      campaign: campaignSearch?.value,
      is_deleted: isDeletedUserSearch === 1 ? 1 : 0,
      is_token: isTokenSearch,
      signup_status: signupStatusSearch,
      start_date: start_date
        ? formatDateStringToUTC(
          moment(new Date(start_date))
            .startOf("day")
            .format("Y-MM-DD HH:mm:ss")
        )
        : "",
      end_date: end_date
        ? formatDateStringToUTC(
          moment(new Date(end_date)).endOf("day").format("Y-MM-DD HH:mm:ss")
        )
        : "",
      //sort_by: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        key_search: "",
        email: "",
        is_active: "",
        country: "KR",
        platform: "",
        bar_id: "",
        os: "",
        ip: "",
        phone: "",
        device_id: "",
        device_model: "",
        udid_2: "",
        channel: "",
        agency: "",
        campaign: "",
        is_deleted: false,
        is_token: "",
        signup_status: "",
        start_date: "",
        end_date: "",
        sort_by: "",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );
    setNicknameSearch((_prev) => "");
    setStatusSearch("");
    setEmailSearch("");
    setBarSearch({
      label: t("All Filter"),
      value: "",
    });
    setPlatFormSearch((_prev) => null);
    setOSSearch("");
    setCountrySearch((_prev: any) => ({ value: "KR", label: '' }));
    setIPAddressSearch((_prev) => "");
    setPhoneSearch((_prev) => "");
    setDeviceIdSearch((_prev) => "");
    setDeviceModelSearch((_prev) => "");
    setUUID2Search((_prev) => "");
    setChannelSearch((_prev: any) => "");
    setIsDeletedUserSearch(0);
    setIsTokenSearch("");
    setSignupStatusSearch("");
    setAgencySearch({
      label: t("All Filter"),
      value: "all",
    });
    setCampaignSearch({
      label: t("All Filter"),
      value: "all",
    });
    setDateSearch([null, null]);
  };

  // Begin::Update User
  const onCloseClick = () => {
    setItemToEdit((_prev: any) => null);
    setIsOpen((_prev) => false);
  };

  const triggerRefresh = () => {
    onCloseClick();
    dispatch(getUsers(query));
  };
  //End::Update User

  // Begin::Change status
  const [isLoadingUpdate, setIsLoadingUpdate] = useState<boolean>(false);

  const handleOnConfirmUpdate = async (item: {
    id: number | string;
    is_active: string | boolean;
  }) => {
    try {
      if (!item) {
        return;
      }
      const response: any = await putUser(item?.id, {
        is_active: item?.is_active,
      });

      if (response?.data) {
        loadTableData();
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoadingUpdate((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };
  // End::Change status

  
  //Begin::Show Notification
  const handleShowNotification = (userID: any) => {
    if(!userID) return;

    setItemNotification(userID)
  }
  
  const handleCloseNotification = () => {
    setItemNotification(null)
  }
  //End::Show Notification


  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 60,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div style={{ width: 35 }}>
              {users?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Active"),
        accessor: "is_active",
        thWidth: 80,
        filterable: false,
        sortable: false,
        thClass: "text-center",
        Cell: (cell: any) => {
          const item = cell?.row?.original;

          return <CheckboxStatusUser item={item} />
        },
      },
      {
        Header: t("Photo"),
        accessor: "profile_image_url",
        thClass: "text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 80,
        Cell: (cell: any) => (
          <>
            <div className="w-100 text-center " style={{ minWidth: "60px" }}>
              <div
                style={{ width: "45px" }}
                className="m-auto cursor-pointer"
                onClick={() => setLinkImage({ url: cell?.value ?? avatar1 })}
              >
                <img
                  src={cell?.value ?? avatar1}
                  className="rounded-circle avatar-sm"
                  alt="thumbnail"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = avatar1;
                  }}
                />
              </div>
            </div>
          </>
        ),
      },
      {
        Header: t("Nickname"),
        accessor: "nickname",
        filterable: true,
        sortable: false,
        thWidth: 180,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            cell?.value && (
              <div className="cursor-pointer" style={{ width: "135px" }}>
                <CopyWrapper contentCopy={cell?.value}>
                  {`${cell?.value}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },

      {
        Header: t("Email"),
        accessor: "email",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return (
            cell?.value && (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={cell?.value}>
                  {`${cell?.value}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },
      {
        Header: t("Phone Number"),
        accessor: "phone",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 150,
        Cell: (cell: any) => {
          const verifiedAt = cell?.row?.original?.verified_at;
          return (
            cell?.value ? (
              <div className="cursor-pointer d-flex flex-column">
                <CopyWrapper contentCopy={cell?.value}>
                  {`${cell?.value}`}
                </CopyWrapper>
                {
                  verifiedAt ? <small style={{ color: "#28A745" }}>{t('Verified')}</small> : <small style={{ color: "#DC3545" }}>{t('Not Verified')}</small>
                }
              </div>
            ) : "-"
          );
        },
      },
      {
        Header: t("Store Name"),
        accessor: "barName",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 170,
        Cell: (cell: any) => {
          const row = cell?.row?.original;
          return (
            row?.bar?.id ? (
              <>
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    setItemToBarDetail(row?.bar);
                  }}
                  style={{
                    width: "150px",
                    color: "#009ef7",
                  }}
                >
                  {row?.bar?.title}
                </div>
              </>
            ) : '-'
          );
        },
      },
      {
        Header: t("Store Location"),
        accessor: "barLocation",
        filterable: true,
        sortable: false,
        thWidth: "150",
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original?.bar;
          const lat = item?.lat;
          const lng = item?.long;

          return (
            (lat || lng) ? (
              <div className="cursor-pointer" style={{ minWidth: "100px" }}>
                <a
                  href={`https://www.google.com/maps/search/${lat},${lng}/@${lat},${lng},17z?entry=ttu`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item?.address}
                </a>
              </div>
            ) : '-'
          );
        },
      },

      {
        Header: t("Platform"),
        accessor: "platform",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          let platform = cell?.row?.original?.platform;

          let imgPlatform = getPlatFormImage(platform);
          return (
            <div className="d-flex flex-column gap-1">
              <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                <div style={{ width: "25px" }}>
                  {imgPlatform && (
                    <img
                      src={imgPlatform}
                      width={25}
                      height={25}
                      alt="platform"
                    />
                  )}
                </div>
                <div className="cursor-pointer">
                  {t(
                    capitalizeFirstLetter(
                      platform == "default" ? "Email" : platform
                    )
                  )}
                </div>
              </div>
            </div>
          );
        },
      },
      {
        Header: t("deviceOS"),
        accessor: "",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          const deviceOS = cell?.row?.original?.user_device?.os;
          let imgOS = getPlatFormImage(deviceOS);

          return (
            deviceOS && (
              <div
                className="d-flex align-items-center"
                style={{ minWidth: "110px" }}
              >
                {imgOS ? (
                  <div style={{ width: "25px" }} className="me-1">
                    {imgOS ? (
                      <img src={imgOS} width={20} height={20} alt="platform" />
                    ) : (
                      <span
                        className={`bg-secondary`}
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "3px",
                        }}
                      ></span>
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div>
                  {t(
                    LIST_OPTION_OS?.find((item) => item?.value === deviceOS)
                      ?.label ?? ""
                  )}
                </div>
              </div>
            )
          );
        },
      },
      {
        Header: t("Device Id"),
        accessor: "device_id",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 220,
        Cell: (cell: any) => {
          const deviceId = cell?.row?.original?.user_device?.device_id;
          return (
            deviceId && (
              <div className="cursor-pointer" style={{ width: 180 }}>
                {t(`${deviceId}`)}
              </div>
            )
          );
        },
      },
      {
        Header: t("Device Model"),
        accessor: "device_model",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 160,
        Cell: (cell: any) => {
          const item = cell?.row?.original?.user_device;
          let deviceModel = item?.device_model;
          const os = item?.os;
          if (os === 'ios') {
            deviceModel = deviceModel ? (IPHONE_MODELS[deviceModel as keyof typeof IPHONE_MODELS] ?? deviceModel) : '';
          }

          return (
            deviceModel && (
              <div className="cursor-pointer" style={{ width: 150 }}>
                {t(`${deviceModel}`)}
              </div>
            )
          );
        },
      },

      {
        Header: t("Manufacturer"),
        accessor: "manufacturer",
        filterable: true,
        sortable: false,
        thWidth: 170,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const manufacturer = cell?.row?.original?.user_device?.manufacturer;
          return (
            manufacturer ? (
              <div className="cursor-pointer" style={{ minWidth: "160px" }}>
                <CopyWrapper contentCopy={manufacturer}>
                  {`${manufacturer}`}
                </CopyWrapper>
              </div>
            ) : '-'
          );
        },
      },

      {
        Header: t("UUID"),
        accessor: "udid",
        filterable: true,
        sortable: false,
        thWidth: 170,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original?.user_device;
          return (
            item?.udid_2 ? (
              <div className="cursor-pointer" style={{ minWidth: "160px" }}>
                <CopyWrapper contentCopy={item?.udid_2}>
                  {`${item?.udid_2}`}
                </CopyWrapper>
              </div>
            ) : '-'
          );
        },
      },

      {
        Header: t("FCM Token"),
        accessor: "token",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 250,
        Cell: (cell: any) => {
          const token = cell?.row?.original?.user_device?.device_token;

          return (
            token ? (
              <div className="cursor-pointer" style={{ maxWidth: "230px" }}>
                <CopyWrapper contentCopy={token} style={{ minWidth: "70px", wordBreak: "break-all" }}>
                  {truncate(token, 45)}
                </CopyWrapper>
              </div>
            ) : '-'
          );
        },
      },

      {
        Header: t("App Version"),
        accessor: "app_version",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 120,
        Cell: (cell: any) => {
          const row = cell?.row?.original;
          const appVersion = row?.app_build
            ? `${cell?.value} (${row?.app_build})`
            : cell?.value;

          return (
            appVersion && (
              <div className="cursor-pointer" style={{ minWidth: "110px" }}>
                <CopyWrapper contentCopy={appVersion}>
                  {`${appVersion}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },
      {
        Header: t("IP"),
        accessor: "providers_ip",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 140,
        Cell: (cell: any) => {
          const ip = cell?.row?.original?.login_log?.ip;
          return (
            ip && (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={ip}>{`${ip}`}</CopyWrapper>
              </div>
            )
          );
        },
      },

      {
        Header: t("Location"),
        accessor: "location",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const lat = item?.lat;
          const lng = item?.long;
          const country = item?.country;

          return lat || lng ? (
            <div className="cursor-pointer" style={{ minWidth: "120px" }}>
              <a
                href={`https://www.google.com/maps/search/${lat},${lng}/@${lat},${lng},17z?entry=ttu`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item?.address || item?.short_address ? (
                  <>{item?.short_address ?? item?.address}</>
                ) : (
                  <span className="d-flex align-items-center gap-1">
                    <i className="ri-map-pin-line"></i> {t("Location")}
                  </span>
                )}
              </a>
            </div>
          ) : (
            <></>
          );
        },
      },

      // {
      //   Header: t("Province/Metropolitan City"),
      //   accessor: "region1",
      //   filterable: true,
      //   sortable: false,
      //   thClass: "whitespace-nowrap",
      //   thWidth: i18n?.language === 'en' ? 220 : 180,
      //   Cell: (cell: any) => {
      //     const region1 = cell?.value;

      //     return (
      //       region1 && (
      //         <div className="cursor-pointer" style={{ minWidth: "110px" }}>
      //           <CopyWrapper contentCopy={region1}>
      //             {`${region1}`}
      //           </CopyWrapper>
      //         </div>
      //       )
      //     );
      //   },
      // },

      // {
      //   Header: t("City/District"),
      //   accessor: "region2",
      //   filterable: true,
      //   sortable: false,
      //   thClass: "whitespace-nowrap",
      //   thWidth: 180,
      //   Cell: (cell: any) => {
      //     const region2 = cell?.value;

      //     return (
      //       region2 && (
      //         <div className="cursor-pointer" style={{ minWidth: "110px" }}>
      //           <CopyWrapper contentCopy={region2}>
      //             {`${region2}`}
      //           </CopyWrapper>
      //         </div>
      //       )
      //     );
      //   },
      // },

      // {
      //   Header: t("Town/Neighborhood"),
      //   accessor: "region3",
      //   filterable: true,
      //   sortable: false,
      //   thClass: "whitespace-nowrap",
      //   thWidth: i18n?.language === 'en' ? 220 : 180,
      //   Cell: (cell: any) => {
      //     const region3 = cell?.value;

      //     return (
      //       region3 && (
      //         <div className="cursor-pointer" style={{ minWidth: "110px" }}>
      //           <CopyWrapper contentCopy={region3}>
      //             {`${region3}`}
      //           </CopyWrapper>
      //         </div>
      //       )
      //     );
      //   },
      // },

      {
        Header: t("Country"),
        accessor: "country",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 120,
        Cell: (cell: any) => {
          const countryCode = cell?.row?.original?.login_log?.country_code;
          const country = countries.find((item) => item?.code == countryCode);

          return (
            countryCode && (
              <div
                className="d-flex flex-column gap-1"
                style={{ minWidth: "130px" }}
              >
                {
                  <div className="cursor-pointer d-flex gap-2 align-items-center ">
                    {country && (
                      <>
                        <img
                          src={country?.flags}
                          width={20}
                          height={20}
                          alt="profile"
                        />
                        <div className="cursor-pointer">
                          {i18n?.language == "ko"
                            ? country?.name_korea
                            : country?.name}
                        </div>
                      </>
                    )}
                  </div>
                }
              </div>
            )
          );
        },
      },
      {
        Header: t("Channel"),
        accessor: "channel",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          let channel = cell?.row?.original?.channel;
          let imgChannel = getPlatFormImage(channel);

          return (
            <div
              className="d-flex flex-column gap-1"
              style={{ minWidth: "100px" }}
            >
              <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                <div style={{ width: "25px" }}>
                  {imgChannel && (
                    <img
                      src={imgChannel}
                      width={25}
                      height={25}
                      alt="channel"
                    />
                  )}
                </div>
                <div className="cursor-pointer">
                  {t(
                    LIST_CHANNEL_USER_OPTION?.find(
                      (item: any) => String(item?.value) === String(channel)
                    )?.label || ""
                  )}
                </div>
              </div>
            </div>
          );
        },
      },
      {
        Header: t('Referral User'),
        accessor: "Referral User",
        thClass: 'align-middle text-start',
        filterable: false,
        sortable: false,
        thWidth: 230,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original?.referrer;

          return (
            <GroupInfoUser item={item} screen="users" />
          );
        },
      },
      {
        Header: `${t("Campaign")}`,
        accessor: "CampaignName",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original?.campaign;
          return (
            item ? (
              <div className="text-center">
                <div>{item?.name}</div>
                <div className="text-primary">{item?.referral_code}</div>
              </div>
            ) : <div className="text-center">-</div>
          );
        },
      },
      {
        Header: `${t("Agency")}`,
        accessor: "AgencyName",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original?.agency;
          return (
            item ? (
              <div className="text-center">
                <div>{item?.agency_name}</div>
                <div className="text-primary">{item?.referral_code}</div>
              </div>
            ) : <div className="text-center">-</div>
          );
        },
      },
      {
        Header: `${t("Permission")}`,
        accessor: "permission",
        filterable: false,
        sortable: false,
        thWidth: i18n?.language === 'en' ? 370 : 310,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <Permission permission={item?.user_device?.granted_permissions} userID={item?.id} handleShowNotification={handleShowNotification} />
          );
        },
      },
      {
        Header: `${t("Term & Conditions")}`,
        accessor: "Term & Conditions",
        filterable: false,
        sortable: false,
        thWidth: 360,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;

          return (
            <TermCondition conditions={item?.user_device?.term_conditions} />
          );
        },
      },
      {
        Header: t("Sign-up Date"),
        accessor: "registered_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },

      {
        Header: t("Last Activity Time"),
        accessor: "last_activity",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const lastLoginTime = cell?.row?.original?.last_activity;
          const date = formatDateStringToKorea(lastLoginTime);

          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, users?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  const handleCloseModalBarDetail = () => {
    setItemToBarDetail(null);
  };

  // Begin::Delete
  const handleActionDelete = async (id: any) => {
    if (!id) {
      return;
    }
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await UserApi?.deleteUser(id);

      if (response?.success) {
        loadTableData();
        setIsConfirmLoading((_prev) => false);
        setItemToDelete(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  // End::Delete

  useEffect(() => {
    document.title = `${t("Menu Manager")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        const [resCountry]: any = await Promise.all([
          countryApi.countries({ page: 1, limit: 20000 }),
        ]);
        setListCountry((_prev: any) => resCountry?.data || []);
        if (query?.country) {
          const _country = resCountry?.data?.find((_c: any) => String(_c?.code) === String(query?.country));
          setCountrySearch((_prev: any) => (_country ? ({ value: _country?.code, label: _country?.name }) : null));
        }
      } catch (error: any) {
        return error;
      }
    };

    handleCallAllOption();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Menu Manager")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={users?.pagination?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          isShow={!!nickNameSearch}
                          label={`${t("Nickname")}`}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Nickname")}...`}
                            value={nickNameSearch}
                            onChange={(e) => setNicknameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Phone Number")}`}
                          isShow={!!phoneSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Phone Number")}...`}
                            value={phoneSearch}
                            onChange={(e) => setPhoneSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Email")} isShow={!!emailSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Email")}...`}
                            value={emailSearch}
                            onChange={(e) => setEmailSearch(e.target.value)}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("IP Address")}
                          isShow={!!ipAddressSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("IP Address")}...`}
                            value={ipAddressSearch}
                            onChange={(e) => setIPAddressSearch(e.target.value)}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={`${t("Device Id")}`}
                          isShow={!!deviceIdSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Device Id")}...`}
                            value={deviceIdSearch}
                            onChange={(e) => setDeviceIdSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={`${t("Device Model")}`}
                          isShow={!!deviceModelSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Device Model")}...`}
                            value={deviceModelSearch}
                            onChange={(e) =>
                              setDeviceModelSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={`${t("UUID")}`}
                          isShow={!!uuid2Search}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("UUID")}...`}
                            value={uuid2Search}
                            onChange={(e) => setUUID2Search(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={STATUS_USER_OPTION_LANG || []}
                            placeholder={`${t("Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_STATUS_POST}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Platform")} isShow={true}>
                          <DropdownPlatform
                            name="platform"
                            placeholder={`${t("Platform")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={platFormSearch || null}
                            onChangeSelect={(e: any) => setPlatFormSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <div>
                          <LabelWrapper label={t("Store")} isShow={true}>
                            <DropdownAsyncBars
                              name="bar"
                              onChangeSelect={(event: any) =>
                                setBarSearch(event)
                              }
                              isMulti={false}
                              placeholder={`${t("Select Store")}...`}
                              isShowIconCheck={false}
                              isAllOption={true}
                              listCheckedUsers={barSearch}
                              isClearable={false}
                            />
                          </LabelWrapper>
                        </div>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("OS")} isShow={true}>
                          <DropdownOptionImage
                            name="os"
                            dataList={LIST_OPTION_OS || []}
                            placeholder={`${t("OS")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={oSSearch || ""}
                            onChangeSelect={(e: any) => setOSSearch(e?.value)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Country")} isShow={true}>
                          <DropdownCountries
                            name="country"
                            dataList={listCountry || []}
                            placeholder={''}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={countrySearch || null}
                            onChangeSelect={(e: any) => setCountrySearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            // isDefaultKorea={true}
                            isManagerPage={true}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Channel")} isShow={true}>
                          <DropdownChannelUser
                            name="channel"
                            placeholder={`${t("Channel")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={channelSearch}
                            onChangeSelect={(e: any) => {
                              setChannelSearch(e?.value);
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Agency")} isShow={true}>
                          <DropdownAsyncAgency
                            name="agency_id"
                            onChangeSelect={(event: any) => {
                              setAgencySearch(event);
                            }}
                            isMulti={false}
                            placeholder={`${t("Select Agency")}...`}
                            isShowIconCheck={false}
                            listCheckedUsers={agencySearch}
                            isAllOption={true}
                            isNotBelongToAgency={false}
                            isClearable={false}
                            keySetValue="referral_code"
                            keywordSearch={"baive_manager"}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Campaign")} isShow={true}>
                          <DropdownAsyncCampaign
                            name="campaign"
                            onChangeSelect={(event: any) =>
                              setCampaignSearch(event)
                            }
                            isMulti={false}
                            placeholder={`${t("Select Campaign")}...`}
                            isShowIconCheck={false}
                            isAllOption={true}
                            listCheckedCampaign={campaignSearch}
                            isClearable={false}
                            isNotBelongToCampaign={false}
                            keySetValue="referral_code"
                            keywordSearch={"baive_manager"}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("FCM Token")} isShow={true}>
                          <DropdownOptionNew
                            name="is_token"
                            dataList={USER_FCM_TOKEN_OPTION || []}
                            placeholder={`${t("FCM Token")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={isTokenSearch}
                            onChangeSelect={(e: any) =>
                              setIsTokenSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            hideSelectedOptions={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Sign-up Status")} isShow={true}>
                          <DropdownOptionNew
                            name="signup_status"
                            dataList={USER_STATUS_SIGNUP_OPTION || []}
                            placeholder={`${t("Sign-up Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={signupStatusSearch}
                            onChangeSelect={(e: any) =>
                              setSignupStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            hideSelectedOptions={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!start_date || !!end_date}
                        >
                          <DatePickerCustom
                            startDate={start_date || null}
                            endDate={end_date || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Deleted User")} isShow={true}>
                          <div
                            className="form-check form-switch form-switch-sm text-center"
                            dir="ltr"
                            style={{
                              width: 80,
                              paddingTop: 10,
                              paddingLeft: 10,
                            }}
                          >
                            <input
                              type="checkbox"
                              className="form-check-input"
                              name="is_active"
                              checked={isDeletedUserSearch === 1}
                              style={{ marginLeft: 0 }}
                              onChange={(e) => {
                                const value = e?.target?.checked;
                                setIsDeletedUserSearch(value === true ? 1 : 0);
                              }}
                            />
                          </div>
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        lg={3}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-bartender-media"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={users?.list?.length ? users?.list : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={users?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(users?.pagination?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isUserLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Modal
          isOpen={!!itemToEdit?._id || isOpen}
          centered={true}
          size="xl"
          scrollable={true}
        >
          <ModalHeader toggle={onCloseClick}>
            <>
              {!!itemToEdit?._id
                ? t("Button Update User")
                : t("Button Create User")}
            </>{" "}
            <>
              {itemToEdit?._id && (" - " + (itemToEdit?.nickname || "") || "")}
            </>
          </ModalHeader>
          <ModalBody>
            <div style={{ minHeight: "calc(100dvh - 200px)" }}>
              <UserForm
                isModal={true}
                id={String(itemToEdit?._id || "")}
                isCopy={!!itemToEdit?.isCopy}
                triggerRefresh={triggerRefresh}
                LIST_OPTION_ROLE={LIST_OPTION_ROLE_LANG}
              />
            </div>
          </ModalBody>
        </Modal>

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete User")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?._id)}
          />
        )}

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        {itemToBarDetail && (
          <Modal
            isOpen={!!itemToBarDetail}
            centered={true}
            size="xl"
            className="modal-fullscreen"
            scrollable={false}
          >
            <ModalHeader toggle={handleCloseModalBarDetail}>
              {itemToBarDetail?.title || ""}
            </ModalHeader>
            <ModalBody>
              <BarListDetail
                barID={itemToBarDetail?.id}
                setLinkImage={setLinkImage}
              // isShowDetail={true}
              />
            </ModalBody>
          </Modal>
        )}

        {itemNotification && (
          <ModalPerNotification
            isOpen={!!itemNotification}
            onClose={handleCloseNotification}
            userID={itemNotification}
          />
        )}

      </div>
    </React.Fragment>
  );
};

export default UserList;
